import { FunctionComponent } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Form from "components/forms/form";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import Dropdown from "components/forms/inputs/dropdown";
import { useForm } from "react-hook-form";
import { OptionInterface } from "components/forms/inputs/dropdown.styles";
import { LocaleString } from "models/locale";
import FormButtons from "components/forms/buttons";
import { FormSubmitFunction } from "lib/form";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";

interface AddListTemplateModalFormProps {
  onSubmit: FormSubmitFunction;
  onClose: () => Promise<void>;
}

export interface FormModel {
  name: LocaleString;
  template: string;
}

const AddListTemplateModalForm: FunctionComponent<
  AddListTemplateModalFormProps
> = ({ onSubmit, onClose }) => {
  const schema = yup
    .object({
      template: yup.string().validateRequired(),
    })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      template: "empty",
    },
  });

  const templateOptions: OptionInterface[] = [
    { value: "empty", text: "Tyhjä luettelomalli" },
    { value: "liability", text: "Sidonnaisuusluettelo" },
  ];

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Grid>
        <Row>
          <Col>
            <Dropdown
              label="Valitse luettelomalli"
              options={templateOptions}
              name="template"
            />
          </Col>
        </Row>
        <FormButtons
          buttons={[{ ...CancelButton, onClick: onClose }, { ...SubmitButton }]}
        />
      </Grid>
    </Form>
  );
};

export default AddListTemplateModalForm;
